import { render } from "./CmsImage.vue?vue&type=template&id=a42cc4f4"
import script from "./CmsImage.vue?vue&type=script&lang=js"
export * from "./CmsImage.vue?vue&type=script&lang=js"

import "./CmsImage.vue?vue&type=style&index=0&id=a42cc4f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__